import React, { useEffect, useState } from "react";

import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import Loader from "../../Layouts/Loader/Loader";
import { useAxiosContext } from "../../context/AxiosContext";
import { SM_TEMPLATES_API } from "../../Api/StateMachine";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import { useModalContext } from "../../context/ModalContext";

import BuilderTabs from "../../Layouts/BuilderTabs";

const SmTemplates = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [templates, setTemplates] = useState([]);

  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const { getUserConfirmationForDelete } = useModalContext();

  const getImage = async (imageName) => {
    if (!imageName) return;

    try {
      // const response = await axios.get(`${BASE_URL}/api/v1${GET_ASSETS_API}${imageName}`, {
      //   headers: {
      //     Authorization: token,
      //     "Zino-App-Id": appId
      //   },
      //   responseType: "arraybuffer"
      // });

      // const blob = new Blob([response.data], {
      //   type: response.headers["content-type"]
      // });

      // const imageUrl = URL.createObjectURL(blob);
      if (document.getElementById(imageName)) {
        document.getElementById(imageName).innerHTML = `<img src="test" alt="Image" />`;
      }
    } catch (error) {
      handleError(error);
    }
  };

  const deleteTemplate = async (smId, name) => {
    try {
      const userConfirmation = await getUserConfirmationForDelete(name);
      if (!userConfirmation) return;

      setIsLoading(true);

      const { message } = await axiosInstance.delete(SM_TEMPLATES_API + "/" + smId);

      handleSuccess(message);

      getTemplates();
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  let tabData;
  if (templates.length > 0)
    tabData = [
      {
        label: "Public",
        content: separateTemplates(templates, deleteTemplate, false)
      },
      {
        label: "Org",
        content: separateTemplates(templates, deleteTemplate, true)
      }
    ];

  const getTemplates = async () => {
    try {
      const { data } = await axiosInstance.get(SM_TEMPLATES_API);

      Promise.all(data.map((template) => getImage(template.image_path, template.app_id)));

      setTemplates(data);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTemplates();
    //eslint-disable-next-line
  }, []);

  let content = null;

  if (isLoading) {
    content = <Loader />;
  } else if (templates.length > 0) {
    content = (
      <div className="dashboard_outer_section">
        <div className="dashboard-top-header">
          <h2 className="">Workflow Templates</h2>
        </div>
        <div className="org-dashboard-page-body flex_column g_5 overflow_hidden">
          <BuilderTabs tabs={tabData} containerClass="themes_tabs" contentClass="w_100 h_100 overflow_auto" />
        </div>
      </div>
    );
  } else {
    content = (
      <div className="not_found_container">
        <p className="not_found_label">No Template Found !</p>
      </div>
    );
  }

  return (
    <div className="application_container">
      <AppLeftSideBar type={"org"} />
      <div className="page_section">{content}</div>
    </div>
  );
};

export default SmTemplates;

const separateTemplates = (templates, deleteTemplate, filterByOrg) => {
  let filteredTemplates = templates;

  if (filterByOrg) {
    filteredTemplates = filteredTemplates.filter((template) => (template.org_id.length > 0 ? true : false));
  } else {
    filteredTemplates = filteredTemplates.filter((template) => (template.org_id.length > 0 ? false : true));
  }

  return (
    <div className="update_theme_container">
      <div className="theme_iframe_container">
        {filteredTemplates.map((template) => (
          <div key={template.id} className="theme_card" style={{ cursor: "default" }}>
            <div className="theme_image">
              <div id={template.image_path}></div>
              <div className="theme_name p_2 flex_row_justify_center_align_center gap_3">
                <label className="theme_label" style={{ marginBottom: "0px" }}>
                  {template.template_name}
                </label>
                <ButtonActionIcon
                  type="delete"
                  size="xsm"
                  onClick={() => {
                    deleteTemplate(template.id, template.template_name);
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
